import React from 'react'
import watsIcon from '../../../assest/home/5357b4eb16238760df0ba166628f1cee41086e44.png';
import styles from '../../../css/services/conServices.module.css'
function ConServices() {
  return (
      <div className={styles.container}>
          <div className={styles.services}>
              <div>
                  <h1>  1. استشارات مالية ومحاسبية </h1>
                  <p>
       تقديم خدمات
                  رية للشركات في 
                                        <br/>
                      الم حاسبة بما فيذلك تحليل
                      <br/>
                                         الأوضاع المالية وتقديم النصائح حول التخطيط 
                       <br/>
المالي، وتحسين الإجراءات المحاسبية 
                </p>
              </div>
              <div>
                <h1>2. استشارات عمالية</h1>
                <p>
                  توفير استشارات تتعلق بقضايا الموارد 
                                      <br/>
                الاستشارية والعمل، مثل إدارة الأداء والتوظيف
     <br/>
                  وسياس ات الموارد البشرية لتعزيز
                  <br/>
  ف
عالية العمل والامتثال للقوانين العمالية.</p>
              </div>
              <div>
                <h1>3. استشارات إستثمارية</h1>
                 <p>
                          وفير خدمات استشارية في مجالات الاستثمار
                          <br/>
                      بما في ذلك تحليل العرض الاستثمارية،
                      <br/>
                      وإعداد الخطط الاستثمارية وتقديم النصائح حول
                      <br/>
                      التنويع في المحافظ الاستثمارية، بهدف تحقيق العوائد 
                      <br/>
المستدامة وتحقيقالأهداف المالية للعملاء.
                </p>
              </div>
          </div>
    </div>
  )
}

export default ConServices